<template>
    <div>
      <textarea id="codemirror_text_area" ref="textarea" :value="value" />
    </div>
  </template>
  
  <script>
  import * as codemirror from 'codemirror';
  import 'codemirror/mode/htmlmixed/htmlmixed.js';
  import 'codemirror/addon/hint/show-hint.js';
  import 'codemirror/addon/hint/sql-hint.js';
  import 'codemirror/lib/codemirror.css';
  import 'codemirror/addon/hint/show-hint.css';
  // import 'codemirror/theme/cobalt.css';
  
  const DEFAULT_OPTIONS = {};
  
  // export
  export default {
    name: 'Codemirror',
    props: {
      value: {
        type: String,
        required: false,
        default() {
          return '';
        },
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        cmRef: undefined,
      };
    },
    computed: {
      computedOptions() {
        return { ...DEFAULT_OPTIONS, ...this.options };
      },
    },
    watch: {
      options: {
        deep: true,
        handler(newVal) {
          for (const key in newVal) {
            this.cmRef.setOption(key, newVal[key]);
          }
        },
      },
    },
  
    mounted() {
      this.$nextTick(() => {
        this.initiate();
      });
    },
    beforeDestroy() {},
    methods: {
      initiate() {
        const textarea = this.$refs.textarea;
        this.cmRef = codemirror.fromTextArea(textarea, this.computedOptions);
  
        this.refresh();
        this.cmRef.setCursor(0, 0);
        this.cmRef.on('keypress', () => {
          // Compiler content change event
          this.cmRef.showHint();
        });
        this.cmRef.on('change', (event) => {
          const value = event.getValue();
          if (this.$emit) {
            this.$emit('input', value);
          }
        });
      },
      refresh() {
        this.cmRef.refresh();
      },
      onInput(event) {
        this.$emit('input', event);
      },
    },
  };
  </script>
  